import {useCookie} from '@aboutyou/storage';
import {
  UserState,
  cleanupUserPersistedState,
  useCustomerResponse,
  useOptionalUser,
  useUser,
} from '@aboutyou/user';
import {useCallback} from 'react';

const transformRawValue = (raw?: string): boolean | undefined => {
  if (raw) {
    return Boolean(raw);
  }
  return undefined;
};

const COOKIE_NAME = 'aym_vip_user';

export const useUpdateUserCacheOnLogout = () => {
  const {updateCache} = useUser();
  const {updateCache: updateCacheOptional} = useOptionalUser();
  const {updateCache: updateCustomerResponseCache} = useCustomerResponse();
  const [_, updateVipUser] = useCookie<boolean | undefined>({
    cookieName: COOKIE_NAME,
    defaultValue: undefined,
    transformRawValue,
  });

  return useCallback(() => {
    cleanupUserPersistedState();
    updateCacheOptional(undefined);

    updateCache({
      checkoutSession: null,
      token: null,
    } as UserState);

    updateCacheOptional({
      userData: null,
    });

    updateCustomerResponseCache(undefined);

    updateVipUser(false);
  }, [updateCache, updateVipUser]);
};
